

import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import TextTransformation from '../../global/textTransformation';
import './menutabs.scss'

export default function MenuTabs(props) {

    const { tabNames = [], setValue, value, mobilePositionFixed = false } = props

    const handleChange = (event, newValue) => {
        if (setValue) {
            setValue(newValue);
        }
        const tabSelector = document.getElementById(newValue);
        //What ever the height of fixed component above TAB section will be needed to be updated to 'yOffset'
        let yOffset = -146;

        if (isMobile && mobilePositionFixed) {
            yOffset = -115;
        } else if (isMobile && !mobilePositionFixed) {
            // value should be double of if block 
            yOffset = -230;
        } else if (isIpad) {
            yOffset = -175;
        }

        const y = tabSelector.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });

    };

    if (isMobile || isIpad) {
        return (
            <Tabs
                value={value || ''}
                onChange={handleChange}
                // textColor="secondary"
                // indicatorColor="secondary"
                // aria-label="Vertical tabs example"
                variant="scrollable"
                scrollButtons={false}
                allowScrollButtonsMobile
                className={isIpad ? 'menu-tabs-container-ipad' : 'menu-tabs-container-mobile'}
                orientation="horizontal"
            >
                {

                    tabNames.map((tab) => {
                        return (<Tab sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-between', width: 'auto' }} value={tab} label={TextTransformation(tab)} key={tab} />)


                    })
                }
            </Tabs>
        )

    }
    return (
        <Tabs
            value={value || ''}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="Vertical tabs example"
            variant="scrollable"
            scrollButtons={false}
            allowScrollButtonsMobile
            className='menu-tabs-container'
            orientation="vertical"
        >
            {
                tabNames.map((tab) => {
                    return (<Tab sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', wordWrap: 'break-word' }} value={tab} label={TextTransformation(tab)} key={tab} />)

                })
            }

        </Tabs>
    );
}
